import { render, staticRenderFns } from "./HintBlock.vue?vue&type=template&id=8addda94&scoped=true&"
import script from "./HintBlock.vue?vue&type=script&lang=ts&"
export * from "./HintBlock.vue?vue&type=script&lang=ts&"
import style0 from "./HintBlock.vue?vue&type=style&index=0&id=8addda94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8addda94",
  null
  
)

export default component.exports